import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import "./stylesheet/Home.css";
import logoImg from "../assets/logo.svg"; 

export default function Home() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  async function handleAccess() {
    if (!code.trim()) {
      setErrorMessage("Por favor, informe o código de acesso para continuar.");
      setShowError(true);
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("accessCodes/validateCode.php", { code });

      if (res.data.success) {
        localStorage.setItem("accessUser", JSON.stringify(res.data.user));
        navigate("/portal");
      } else {
        setErrorMessage(res.data.message || "Código inválido ou expirado.");
        setShowError(true);
      }
    } catch {
      setErrorMessage("Erro de conexão. Tente novamente mais tarde.");
      setShowError(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="home-container">
      <div className="logo-container">
        <img src={logoImg} alt="HelpDesk Logo" className="header-logo-img" />
      </div>

      <div className="central-suporte-content">
        <h1 className="content-title">Central de Suporte</h1>
        <p className="content-subtitle">
          Abra chamados e agende eventos de forma rápida e simples
        </p>

        <div className="access-card">
          <div className="card-title-group">
            <span className="card-title-text">Código de Acesso</span>
          </div>

          <input
            type="text"
            placeholder="Digite seu código"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            className="input-access-code"
            disabled={loading}
            onKeyDown={(e) => e.key === 'Enter' && handleAccess()}
          />

          <button
            onClick={handleAccess}
            className="button-access"
            disabled={loading}
          >
            {loading ? "Validando..." : "Acessar"}
          </button>

          <button onClick={() => navigate("/admin")} className="admin-link">
          Acesso Administrativo
        </button>
          
        </div>

        {/* NOVO: Card de Contato TI */}
        <section className="contact-section">
          <div className="contact-card">
            <div className="contact-header">
              <h3>Suporte Direto TI</h3>
            </div>
            <div className="contact-details">
              <p><strong>E-mail:</strong> suporteinformatica1@iesje.com</p>
              <p><strong>Celular:</strong>(35) 3333-4444</p>
            </div>
          </div>
        </section>
      </div>

      {/* RODAPÉ DO DESENVOLVEDOR */}
      <footer className="dev-footer">
        <p>Desenvolvido por <strong>Caique Magalhães</strong> &copy; 2025</p>
      </footer>

      {/* POPUP DE ERRO */}
      {showError && (
        <div className="error-overlay">
          <div className="error-popup-card">
            <div className="error-icon-circle">!</div>
            <h3>Atenção</h3>
            <p>{errorMessage}</p>
            <button className="error-close-btn" onClick={() => setShowError(false)}>
              Entendido
            </button>
          </div>
        </div>
      )}
    </div>
  );
}